import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "f-ac-options__content" }
const _hoisted_2 = {
  key: 0,
  class: "f-autocomplete__modal-option-custom"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["innerHTML"]

import {
  FormAutoCompleteOptionsEmits,
  FormAutoCompleteOptionsProps,
} from '@/types/form/form-auto-complete';
import { FormDropdownOption } from '@/types/form/form-dropdown/form-dropdown';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormAutoCompleteOptions',
  props: {
    value: {},
    loading: { type: Boolean },
    options: {}
  },
  emits: ["option-click"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;
const onOptionClick = (option: FormDropdownOption) => {
  emit('option-click', option);
};

return (_ctx: any,_cache: any) => {
  const _component_content_loading = _resolveComponent("content-loading")!

  return (_openBlock(), _createBlock(_component_content_loading, {
    class: "f-ac-options",
    loading: __props.loading
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (_ctx.$slots.option)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _renderSlot(_ctx.$slots, "option", { option: option })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["f-ac-options__option", { selected: option.value.trim() === __props.value?.trim() }]),
              onClick: ($event: any) => (onOptionClick(option))
            }, [
              _createElementVNode("div", {
                class: "f-ac-options__option-text",
                innerHTML: option.text
              }, null, 8, _hoisted_4)
            ], 10, _hoisted_3)
          ], 64))
        }), 128))
      ])
    ]),
    _: 3
  }, 8, ["loading"]))
}
}

})